import * as React from 'react'
import { useDispatch } from 'react-redux'
import { setIsStored } from '../../../redux/slices/Alerts'
import { Box, Paper, Divider, Grid } from '@mui/material'
import { datasetFormik } from './datasetFormik'
import { Formik, Form } from 'formik'
import BottonInside from '../../BottonCustom/BottonInside'
import Textfield from '../../FormsUI/Textfield'
import * as service from '../../../services'
import Modal from '../../FormCreationModal'
import Select from '../../FormsUI/Select'

const gridStyle = {
  mt: 0,
  width: '100%',
  ml: 0,
  textAlignLast: 'right',
  justifyContent: 'space-evenly',
  pr: 2,
}

const FamilyFormModal = (props, ref) => {
  const dispatch = useDispatch()

  const [formik, setFormik] = React.useState(null)
  const [open, setOpen] = React.useState(false)

  const handleCancelAction = () => setOpen(false)

  const handleAddAction = async (values, TOKEN) => {
    let resultSave = { stored: true }
    const { family_, habilitado } = values
    const data = { nombre: family_, habilitado: Boolean(habilitado) }
    const respoCreatedSpecie = await service.createFamily(data, TOKEN)

    if (respoCreatedSpecie.actions === 'notCreated')
      resultSave = { stored: false, message: respoCreatedSpecie?.message }
    return resultSave
  }

  const otherPropsControl = {
    InputProps: { readOnly: false },
    variant: 'outlined',
  }

  React.useImperativeHandle(ref, () => ({ openModal: () => setOpen(true) }))

  React.useEffect(() => {
    if (!open) return
    datasetFormik().then(variables => setFormik(variables))
    return () => setFormik(null)
  }, [open])

  if (!Boolean(formik)) return null

  return (
    <div>
      <Modal
        open={open}
        title="Crear una familia"
        description="Agregue una nueva familia al registro actual.">
        <Box>
          <Formik
            initialValues={{ ...formik?.INITIAL_FORMIK_STATE }}
            validationSchema={formik?.FORM_VALIDATION}
            onSubmit={async values => {
              const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`
              const itsStored = await handleAddAction(values, TOKEN)
              handleCancelAction()
              dispatch(setIsStored(itsStored))
            }}>
            <Form>
              <Paper
                style={{
                  height: '100%',
                  overflow: 'auto',
                  borderRadius: 0,
                }}>
                <Divider />
                <Grid container spacing={2} sx={{ ...gridStyle }}>
                  {formik?.ITEMS_FAMILY_FORMIK.map((o, i) => {
                    const child = !o.options ? (
                      <Textfield {...otherPropsControl} {...o} />
                    ) : (
                      <Select key={`InPut-${i}`} {...o} {...otherPropsControl} />
                    )
                    return (
                      <Grid
                        key={`InPut-${i}`}
                        item
                        xs={o.x}
                        sx={{ textAlignLast: 'center' }}>
                        {child}
                      </Grid>
                    )
                  })}
                </Grid>
                <Divider sx={{ pt: 2 }} />
                <BottonInside enableButton={true} hdleButtonCancel={handleCancelAction} />
              </Paper>
            </Form>
          </Formik>
        </Box>
      </Modal>
    </div>
  )
}
export default React.forwardRef(FamilyFormModal)
